// This is the entry point for the home component
import React, { FC } from 'react';
import classNames from 'classnames';
import injectSheet from 'react-jss';
import { Loading } from 'Components/Loading';
import { Link } from '../../../../utils/router';
import styleSheet from './styles';
import Profile from './Profile';

interface Props {
  firstName: string;
  lastName: string;
  email: string;
  navList: Array<object>;
  classes?: any;
  active: string;
  changeUniversity: any;
  onClick?: (event: EventTarget) => void;
  ariaLabel?: string;
  profileData: any;
}

export const Nav: FC<Props> = (props: Props) => {
  const {
    firstName = '-',
    lastName = '-',
    email = '-',
    navList,
    classes,
    active,
    changeUniversity,
    onClick,
    ariaLabel,
    profileData,
  } = props;

  const chosenHeader: any = navList.filter((item: any) =>
    active.startsWith(item.baseLink)
  )[0];

  const click = (e: any) => {
    if (onClick) onClick(e.target);
  };

  return (
    <div
      id="nav"
      style={{
        height: chosenHeader && chosenHeader.subHeaders ? '110px' : '72px',
      }}
    >
      <div className={classes.navHolder}>
        <nav aria-label={ariaLabel} className={classes.nav}>
          <div className={classes.container}>
            <Link className={classes.eab} to="/">
              EAB
            </Link>
            <ul className={classes.listItems}>
              {navList.map((item: any) => {
                return (
                  <li
                    key={item.link}
                    className={classNames({
                      [classes.activeTop]: active.startsWith(item.baseLink),
                    })}
                  >
                    <Link onClick={click} to={`${item.link}`}>
                      {item.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
            {profileData.instName.length === 0 && (
              <div>
                <Loading />
              </div>
            )}
            {profileData.instName.length > 0 && (
              <Profile
                firstName={firstName || '-'}
                lastName={lastName || '-'}
                email={email || '-'}
                profileData={profileData}
                changeUniversity={changeUniversity}
              />
            )}
          </div>
        </nav>
        {chosenHeader && chosenHeader.subHeaders && (
          <>
            <nav className={classes.subNav}>
              <div className={classes.subNavContainer}>
                <ul className={classes.ul}>
                  {chosenHeader.subHeaders.map((header: any) => {
                    const checkSubHeader =
                      header.otherLinks &&
                      header.otherLinks.filter((item: any) =>
                        active.startsWith(item)
                      ).length;

                    return (
                      <li
                        key={header.link}
                        className={classNames({
                          [classes.active]:
                            active === header.link || checkSubHeader,
                        })}
                      >
                        <Link onClick={click} to={`${header.link}`}>
                          <span
                            className={classNames({
                              [classes.inactive]:
                                active !== header.link && !checkSubHeader,
                            })}
                          >
                            {header.label}
                          </span>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </nav>
          </>
        )}
      </div>
    </div>
  );
};
Nav.defaultProps = {
  classes: {},
  onClick: () => {},
  ariaLabel: '',
};
export default injectSheet(styleSheet)(Nav);
try {
    // @ts-ignore
    Nav.displayName = "Nav";
    // @ts-ignore
    Nav.__docgenInfo = { "description": "", "displayName": "Nav", "props": { "firstName": { "defaultValue": null, "description": "", "name": "firstName", "required": true, "type": { "name": "string" } }, "lastName": { "defaultValue": null, "description": "", "name": "lastName", "required": true, "type": { "name": "string" } }, "email": { "defaultValue": null, "description": "", "name": "email", "required": true, "type": { "name": "string" } }, "navList": { "defaultValue": null, "description": "", "name": "navList", "required": true, "type": { "name": "object[]" } }, "classes": { "defaultValue": { value: "{}" }, "description": "", "name": "classes", "required": false, "type": { "name": "any" } }, "active": { "defaultValue": null, "description": "", "name": "active", "required": true, "type": { "name": "string" } }, "changeUniversity": { "defaultValue": null, "description": "", "name": "changeUniversity", "required": true, "type": { "name": "any" } }, "onClick": { "defaultValue": { value: "() => {}" }, "description": "", "name": "onClick", "required": false, "type": { "name": "(event: EventTarget) => void" } }, "ariaLabel": { "defaultValue": { value: "" }, "description": "", "name": "ariaLabel", "required": false, "type": { "name": "string" } }, "profileData": { "defaultValue": null, "description": "", "name": "profileData", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Headers/Nav/Nav.tsx#Nav"] = { docgenInfo: Nav.__docgenInfo, name: "Nav", path: "src/shared/components/Headers/Nav/Nav.tsx#Nav" };
}
catch (__react_docgen_typescript_loader_error) { }